// @generated source--
// scripts/generate-bits/file-generators/component-story-map.generator.ts

export const componentStoryMap: {
  [name: string]: {
    path: string;
    tags: string[];
    internalOnly: boolean;
    stories: string[];
    description: string;
  };
} = {
  'anchor-scroll': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'if-needed', 'inline'],
    description:
      'Provides a consistent & performant way to achieve scrolling animations',
  },
  'animated-svg': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: ['default', 'animated-svg-list', 'loading-methods'],
    description:
      'Component used to display animated Scalable Vector Graphics (SVG)',
  },
  'annotation-indicator': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'no-animation'],
    description: 'Indicator for a note of explanation or comment',
  },
  badge: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: [
      'default',
      'corporate',
      'exam',
      'membership',
      'preferred-freelancer',
      'recruiter',
      'rising-star',
      'sizes',
      'staff',
      'user',
      'verified',
    ],
    description: 'Badges that represent a user subscription',
  },
  'banner-alert': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: ['default', 'bordered', 'closeable', 'compact', 'level', 'types'],
    description: 'Banners which inform users about important things',
  },
  'banner-announcement': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: ['default', 'buttons'],
    description:
      'Announcement Banner are used to display extremely important messages that has affects the whole website experience.',
  },
  'banner-upsell': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'adding-button', 'adding-image', 'colors', 'sizes'],
    description: 'Banner for upselling products',
  },
  breadcrumbs: {
    path: '',
    tags: ['navigation'],
    internalOnly: false,
    stories: ['default', 'current', 'disabled', 'mobile-show-breadcrumb'],
    description:
      "A breadcrumb trail on a page indicates the page's position in the site hierarchy.",
  },
  button: {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'button-group',
      'button-icons',
      'button-link',
      'colors',
      'example',
      'hierarchy',
      'responsive',
      'sizes',
      'states',
    ],
    description: 'Clickable elements for anything you want people to click on',
  },
  callout: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'backdrop',
      'border-radius',
      'colors',
      'crawlable',
      'delay',
      'edge-to-edge',
      'hide-close-button',
      'hover',
      'inline',
      'mobile-dropdown',
      'mobile-fullscreen',
      'placement',
      'sizes',
      'smart-positioning',
    ],
    description: 'Popouts for rich tooltips',
  },
  'camera-input': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'custom-title-and-cta', 'trigger-type'],
    description:
      'Appears on top of the main content as a modal and active the camera of the laptop or device.',
  },
  'card-list': {
    path: '',
    tags: ['cards'],
    internalOnly: true,
    stories: ['default', 'select-color', 'selectable', 'sizes'],
    description: 'Displays a styled list of cards that users can choose from.',
  },
  card: {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: [
      'default',
      'border',
      'border-color',
      'clickable',
      'closeable',
      'edge-to-edge',
      'expandable',
      'flex-align-items',
      'flex-direction',
      'flex-justify-content',
      'header-right',
      'highlight',
      'levels',
      'ribbon-implementation',
      'sizes',
      'tabs-implementation',
    ],
    description: 'Wrapping containers for consistently styled cards',
  },
  carousel: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'animation-speed',
      'arrow-backdrop',
      'arrow-icon',
      'arrow-position',
      'autoplay',
      'dot-indicator',
      'dot-indicator-position',
      'scroll-behaviour',
      'show-peek-slide',
      'wrap-around',
    ],
    description: 'A generic slideshow for cycling through a series of content.',
  },
  chart: {
    path: '',
    tags: ['charts'],
    internalOnly: true,
    stories: ['default'],
    description: 'Graphical representation of data in a form of bar.',
  },
  'checkbox-card': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'alignment',
      'border',
      'colors',
      'disable',
      'hide-checkbox',
      'level',
      'validation',
    ],
    description: 'Checkbox input with built-in layouting subcomponents',
  },
  checkbox: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'disable', 'size', 'validation'],
    description:
      'Checkboxes for giving users the ability to choose zero, one or more items from a range of options.',
  },
  container: {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: ['default', 'mobile-padding', 'sizes'],
    description:
      "The container component is used to literally contain elements using standard maximum widths and center it in the page. This component doesn't have any paddings by default in mobile but supports side notches.",
  },
  'countdown-timer': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A countdown timer that displays a circular progress bar to represent the remaining time.',
  },
  'currency-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'background-color',
      'budget',
      'budget-type',
      'disabled-options',
      'label',
      'loading',
      'option-visibility',
      'type',
    ],
    description: 'Currency input field',
  },
  'date-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'compact-date-input', 'date-range', 'disabled'],
    description:
      'A text input that picks a date or a date range from a calendar',
  },
  'date-range-calendar': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description: 'An always-open calendar for selecting a date range',
  },
  'display-card': {
    path: '',
    tags: ['cards'],
    internalOnly: true,
    stories: ['default', 'entry-card-implementation', 'levels'],
    description: 'Cards with built-in layouting subcomponents',
  },
  drawer: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'backdrop-behavior',
      'edge-to-edge',
      'full-height-draggable',
      'full-width',
      'handler-bottom-margin',
      'hide-close-button',
      'overlay-stacking',
      'position',
      'sizes',
    ],
    description:
      'An overlay panel that slides in to display additional content',
  },
  'dropdown-filter': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'autoclose',
      'content-size',
      'disabled',
      'display',
      'edge-to-edge',
      'filter-applied',
      'full-width',
      'hide-dropdown-icon',
      'icon-fill',
      'icon-label',
      'icon-only',
      'logo',
      'mobile-dropdown',
      'mobile-dropdown-bottom',
      'size',
      'text-button',
      'unread-indicator',
    ],
    description: 'A button which displays a rich popout',
  },
  'emoji-picker': {
    path: '',
    tags: ['messaging / conversational ui'],
    internalOnly: true,
    stories: ['default', 'picker-size'],
    description: 'A emoji selector',
  },
  'file-display': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'filename', 'icon-types', 'sizes', 'types'],
    description:
      'Icons with backgrounds that can be used to display/preview a file',
  },
  'file-select': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'alignment',
      'attachment-icon',
      'button',
      'custom-content',
      'file-type-hint',
      'note',
      'preview',
      'validation',
    ],
    description: 'User interfaces for file attachments',
  },
  'file-viewer': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: ['default'],
    description: 'A component that handles file previewing',
  },
  flag: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'sizes'],
    description: 'Icons for displaying country flags',
  },
  'floating-action': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: ['default', 'colors', 'icon-only', 'positions', 'sizes'],
    description:
      'Floating action is used to notify and provide action for the user.',
  },
  focus: {
    path: '',
    tags: ['forms'],
    internalOnly: true,
    stories: ['default', 'autofocus'],
    description: 'A service for focusing elements',
  },
  fonts: {
    path: '',
    tags: ['typography'],
    internalOnly: false,
    stories: ['font', 'titles', 'subtitles', 'body', 'buttons', 'links'],
    description:
      'Learn how we integrate typography across our product ecosystem.',
  },
  'form-save': {
    path: '',
    tags: ['forms'],
    internalOnly: true,
    stories: ['default'],
    description: 'Form Save',
  },
  'gallery-grid': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'aspect-ratio',
      'hide-filename',
      'max-columns',
      'max-rows',
      'reordering',
      'responsive',
      'showcase-card',
      'zoom-on-hover',
    ],
    description: 'Grid preview of files',
  },
  'gallery-mosaic': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: [
      'default',
      'interactive-content',
      'item-spacing',
      'rounded-corners',
      'single-image-fit',
    ],
    description: 'Grid preview of files',
  },
  'generic-error': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'align', 'custom-retry', 'font-style', 'message'],
    description:
      'Generic error messages which  contain standardised instructions and actions for unknown errors.',
  },
  grid: {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: ['default', 'alignment', 'offsetting', 'reordering'],
    description:
      'The grid system in Freelancer is a 12 column based Flexbox grid system. It’s fully responsive using a mobile first approach.',
  },
  'highlight-text': {
    path: '',
    tags: ['typography'],
    internalOnly: true,
    stories: [
      'default',
      'anchor-scroll',
      'background-color',
      'inline',
      'text-color',
    ],
    description:
      'Styled text for showing text with specific chunks highlighted',
  },
  highlight: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: ['default', 'callout', 'round-corners'],
    description: 'Highlighting a component',
  },
  hr: {
    path: '',
    tags: ['typography'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'font-weight',
      'text-sizes',
      'text-transform',
      'with-text',
    ],
    description:
      'a horizontal divider to emphasize end of a section and start of a new section',
  },
  icon: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: [
      'default',
      'backdrop',
      'button',
      'click-animation',
      'colors-and-sizes',
      'disabled',
      'drop-shadow',
      'hover-animation',
      'icon-font-list',
      'icon-font-weight',
      'ng-icon-list',
      'offset',
      'use-ng-icon',
    ],
    description: 'Icons from our icon set',
  },
  'image-cropper': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: false,
    stories: ['default', 'aspect-ratio'],
    description: 'Image cropper is used to resize and crop a given image.',
  },
  'infinite-scroll': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'page-size'],
    description: 'Allows to implement an infinite scrolling pattern',
  },
  input: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'align',
      'animated-placeholders',
      'background-color',
      'button',
      'disabled',
      'edit-inline',
      'edit-inline-title-size',
      'hint',
      'icons',
      'keyboard-type',
      'labels',
      'max-character',
      'max-length',
      'min-value',
      'sizes',
      'states',
      'types',
      'usage',
      'validation',
    ],
    description: 'Inputs that accept typed input from users',
  },
  label: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description: 'Labels used in forms to provide descriptions for inputs',
  },
  link: {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'animated-icon',
      'capitalization',
      'colors',
      'flex',
      'hover-colors',
      'link-action',
      'link-icon',
      'sizes',
      'types',
    ],
    description: 'Anchor tags used for embedded links or smaller actions',
  },
  list: {
    path: '',
    tags: ['layouts'],
    internalOnly: true,
    stories: [
      'default',
      'bordered',
      'checkbox',
      'clickable',
      'dismiss',
      'expandable',
      'horizontal-padding',
      'keyboard-boundary',
      'keyboard-support',
      'ordered-unordered',
      'padding',
      'radio',
      'selectable',
      'selected',
      'toggle',
      'transparent',
    ],
    description: 'Generic vertical layout components',
  },
  'loading-template': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A placeholder to be used in place of content being fetched from network',
  },
  'location-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'detect-location',
      'disabled',
      'display-postal-code',
      'set-value',
    ],
    description: 'An autocompleting text-box for location input',
  },
  logo: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'background-color', 'sizes'],
    description: 'A Freelancer logo',
  },
  map: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'custom-markers',
      'hide-landmarks',
      'interactive',
      'sizes',
      'tooltip',
    ],
    description: 'A component to display a map',
  },
  margin: {
    path: '',
    tags: ['layouts'],
    internalOnly: true,
    stories: ['custom-margins'],
    description: 'Custom margin utilities for layout spacing',
  },
  'media-viewer': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'adding-caption',
      'download-gallery-item',
      'enabling-zoom-click-animation',
      'inline-mode',
      'media-types',
      'modal-mode',
      'photo-rotations',
    ],
    description: 'File viewer modal for files',
  },
  modal: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'closeable',
      'colors',
      'edge-to-edge',
      'mobile-custom-view-header',
      'mobile-fullscreen',
      'rounded-close-button',
      'sizes',
    ],
    description:
      'Appears on top of and disables the main content until it has been explicitly interacted with',
  },
  'more-options': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'disabled',
      'icon-type',
      'mobile-dropdown',
      'sizes',
    ],
    description: 'Displays a list of action items',
  },
  'multi-select': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'adding-text',
      'allow-input-on-blur',
      'counter',
      'dropdown-item-select-color',
      'dropdown-overlay',
      'hide-input-on-non-empty',
      'invalid-inputs',
      'items',
      'max-length',
      'max-rows',
      'options',
      'secondary-placeholder',
      'show-highlight-initially',
      'show-plus-icon',
      'validation',
    ],
    description: 'Multiselects for typing multiple options',
  },
  'multiple-location-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'sizes'],
    description:
      'Multiple location input field for autocompleting "from" and "to" locations',
  },
  'new-feature-tag': {
    path: '',
    tags: ['tags'],
    internalOnly: true,
    stories: ['default'],
    description: 'Displays a unique tag to show that something is new.',
  },
  'online-indicator': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'border', 'responsive', 'sizes'],
    description: 'Indicator if user is online or offline',
  },
  'otp-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default'],
    description:
      'OTP input component for entering one-time passwords and verification codes. Renders a series of single-digit input boxes that automatically advance focus as the user types.',
  },
  'page-layout': {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: [
      'default',
      'min-height',
      'page-size',
      'secondary',
      'split-extend',
    ],
    description:
      'page-layout is the base standard component to house all of the components in a page. This component contains the standard background color, maximum width and minimum height.',
  },
  pagination: {
    path: '',
    tags: ['navigation'],
    internalOnly: false,
    stories: ['default', 'compact', 'extremeties', 'mobile-compact', 'outline'],
    description: 'A simple pagination component',
  },
  'phone-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'auto-focus',
      'country-priority',
      'default-country',
      'validation',
    ],
    description: 'Phone number input field',
  },
  picture: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'aspect-ratio-value',
      'background-image',
      'bounded-height',
      'bounded-width',
      'fallback',
      'fixed-aspect-ratio',
      'full-width',
      'image-sources',
      'lazy-load',
      'object-fit',
      'preload-image',
      'width-and-height',
      'zoom-on-hover',
    ],
    description: 'Media components used to display asset images',
  },
  'progress-bar': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: [
      'default',
      'checkpoints',
      'colors',
      'rounded-corners',
      'secondary-progress',
      'show-progress-marker',
      'sizes',
      'vertical-orientation',
    ],
    description: 'A widget for showing unitless progress',
  },
  'progress-steps': {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: [
      'default',
      'center-edge-text',
      'changing-orientation',
      'clickable-steps',
      'hide-callout',
      'mobile-large-indicator',
      'skipped-steps',
      'start-step',
      'substep',
      'type',
      'vertical-orientation',
    ],
    description:
      'A widget for showing progress of the user on a funnel with multiple steps',
  },
  'pull-refresh': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default', 'drawer-type', 'scroll-basis', 'spinner-type'],
    description:
      'A container component that streamlines the implementation of pull-to-refresh functionality.',
  },
  radio: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'disable', 'size', 'validation'],
    description: 'Inputs to select one of multiple options',
  },
  rating: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: [
      'default',
      'background-color',
      'compact',
      'half-rating',
      'inline',
      'read-only',
      'review-count',
      'size',
      'ticks-color',
      'type',
      'validation',
    ],
    description:
      'The Rating component is a five star rating system for users who work together to rate each other based on their experience',
  },
  'relative-time': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: [
      'default',
      'color',
      'include-seconds',
      'input-types',
      'responsive',
      'secondary-unit',
      'short-format',
      'size',
      'static',
      'strict',
      'suffix',
      'time-passed',
      'weight',
    ],
    description: 'Simple time-ago components with optional live updating',
  },
  ribbon: {
    path: '',
    tags: ['reputation'],
    internalOnly: true,
    stories: ['default', 'colors', 'icon', 'placement'],
    description: 'Coloured strips used to highlight components',
  },
  search: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'background-color',
      'borderless',
      'expandable',
      'round-corners',
      'with-custom-control',
      'with-custom-left-icon',
      'with-debounce-time',
      'with-scrollable-search-results',
      'without-result-display',
    ],
    description:
      'A general purpose search component with optional result display',
  },
  'segmented-date-input': {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'bounds', 'calendar', 'disabled'],
    description: 'Segmented date input',
  },
  select: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'disabled',
      'flags',
      'grouped-options',
      'key-value-object',
      'sizes',
      'validation',
    ],
    description: 'Inputs for selecting from a menu of items',
  },
  'share-buttons': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default', 'mobile', 'shareicons', 'showtext', 'sizes'],
    description: "Social Media Platform's sharing buttons",
  },
  'share-link': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default'],
    description: 'Component that allows users to copy a shareable link.',
  },
  slider: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'double', 'label-position'],
    description:
      'Inputs for choosing a value or a range inside a range of values',
  },
  'smart-textarea': {
    path: '',
    tags: ['forms', 'popups / overlays'],
    internalOnly: false,
    stories: ['default', 'callout-positioning', 'callout-visibility'],
    description:
      'Provides ability to show customized callouts inside textareas based on user text selection events',
  },
  'social-buttons': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: ['default', 'colors', 'fluid', 'share-buttons', 'sizes'],
    description:
      'Icons for linking to social media platforms or providing sharing buttons',
  },
  spinner: {
    path: '',
    tags: ['progress & loading indicators'],
    internalOnly: false,
    stories: ['default', 'bird', 'overlay', 'sizes-and-colors'],
    description: 'A component that indicates loading or processing',
  },
  'split-button': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'full-width',
      'icons',
      'links',
      'responsive',
      'sizes',
      'states',
    ],
    description:
      'A button which allows the user to execute a default action or to choose a predefined action from a drop-down list',
  },
  'sticky-footer': {
    path: '',
    tags: ['layouts'],
    internalOnly: true,
    stories: ['default', 'alignment', 'fixed'],
    description: 'Mobile footers which go at the bottom of the view',
  },
  table: {
    path: '',
    tags: ['layouts'],
    internalOnly: false,
    stories: [
      'default',
      'edge-to-edge',
      'expandable',
      'expandable-mobile',
      'fixed-layout',
      'flash-highlight',
      'header-color',
      'header-font-weight',
      'highlight',
      'highlight-border',
      'hover',
      'mobile-view-compact',
      'mobile-view-shading',
      'no-border',
      'no-wrap',
      'padding-size',
      'pagination',
      'pagination-position',
      'responsive',
      'row-links',
      'row-track-by',
      'separators',
      'sortable',
      'text-align',
      'title-callout',
      'vertical-alignment',
    ],
    description: 'Tables for displaying dynamic data',
  },
  tabs: {
    path: '',
    tags: ['navigation'],
    internalOnly: false,
    stories: [
      'default',
      'alignment',
      'bordered',
      'colors',
      'direction',
      'icon',
      'image',
      'media-position',
      'more-options',
      'router',
      'router-with-query',
      'size',
      'subtitle',
      'truncate',
    ],
    description: 'Tabs used to switch between different views',
  },
  'tag-status': {
    path: '',
    tags: ['tags'],
    internalOnly: true,
    stories: [
      'default',
      'background-color',
      'colors',
      'icon',
      'sizes',
      'usage',
    ],
    description: 'Displays the status of the project / contest',
  },
  tag: {
    path: '',
    tags: ['tags'],
    internalOnly: false,
    stories: [
      'default',
      'borderless',
      'colors',
      'icon-only',
      'icons',
      'link',
      'max-lines',
      'selectable',
      'sizes',
      'types',
    ],
    description:
      'Tags for skills or filters, which can be clicked or dismissed',
  },
  text: {
    path: '',
    tags: ['typography'],
    internalOnly: true,
    stories: [
      'default',
      'align',
      'colors',
      'decoration',
      'highlight',
      'max-lines',
      'responsive',
      'sizes',
      'styles',
      'transform',
      'weights',
      'whitespace',
    ],
    description: 'Text that is styled via the tailwind utility classes.',
  },
  textarea: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: [
      'default',
      'auto-grow',
      'border-radius',
      'borderless',
      'clear-button',
      'disabled',
      'display-character-count',
      'events',
      'icon-start',
      'max-character',
      'max-height',
      'max-length',
      'placeholder-color',
      'prevent-newlines',
      'validation',
    ],
    description: 'Multi-line inputs for forms',
  },
  'thumbnail-viewer': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: ['default', 'group-scrolling', 'hide-arrows'],
    description: 'A slideshow for cycling through a list of thumbnails.',
  },
  timepicker: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'validation'],
    description: 'Time selection input built on Angular Material',
  },
  'toast-alert': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: false,
    stories: [
      'default',
      'closeable',
      'colors',
      'dynamic',
      'persist-when-hover',
      'types',
    ],
    description:
      'Toast alerts are displayed at the top and center, just below the header nav.',
  },
  'toggle-buttons': {
    path: '',
    tags: ['buttons & actions'],
    internalOnly: false,
    stories: [
      'default',
      'colors',
      'equal-option-width',
      'full-width',
      'icons',
      'size',
      'variant',
    ],
    description: 'Toggle buttons group',
  },
  toggle: {
    path: '',
    tags: ['forms'],
    internalOnly: false,
    stories: ['default', 'colors', 'sizes', 'states'],
    description: 'Simple toggle switches',
  },
  tooltip: {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: false,
    stories: ['default'],
    description:
      'A tooltip is a floating, non-actionable label used to explain a UI element, feature or to provide additional information.',
  },
  'unread-indicator': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default', 'border', 'color', 'counter', 'position', 'sizes'],
    description: 'Indicator for unread messages',
  },
  'user-activity-status': {
    path: '',
    tags: ['alerts & notifications'],
    internalOnly: true,
    stories: ['default'],
    description:
      'Wrapper over the online indicator which displays either the last active time within 24 hours or if the user is online.',
  },
  'user-avatar': {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'group',
      'letter',
      'loading',
      'online-status',
      'responsive',
      'sizes',
      'video-avatar',
    ],
    description: 'Components for showing user profile images',
  },
  'validation-error': {
    path: '',
    tags: ['forms'],
    internalOnly: true,
    stories: ['default', 'custom'],
    description: 'Validation error which shows up on invalid form responses.',
  },
  'video-modal': {
    path: '',
    tags: ['popups / overlays'],
    internalOnly: true,
    stories: ['default'],
    description: 'Modal for displaying the video component',
  },
  video: {
    path: '',
    tags: ['icons / images / media'],
    internalOnly: true,
    stories: [
      'default',
      'auto-hide-controls',
      'auto-play',
      'auto-play-on-hover',
      'disable-controls',
      'object-fit',
      'playback-speed',
      'time-display',
    ],
    description: 'Media players for playing video files',
  },
  'view-header': {
    path: '',
    tags: ['navigation'],
    internalOnly: true,
    stories: ['default', 'backgrounds', 'show-back-button'],
    description: 'Mobile headers which go at the top of views',
  },
  widget: {
    path: '',
    tags: ['cards'],
    internalOnly: false,
    stories: ['default'],
    description: 'The widget card display the information in a single element.',
  },
};
